import { render } from "./Mycollections.vue?vue&type=template&id=4d693d99&scoped=true"
import script from "./Mycollections.vue?vue&type=script&lang=js"
export * from "./Mycollections.vue?vue&type=script&lang=js"

import "./Mycollections.vue?vue&type=style&index=0&id=4d693d99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4d693d99"

export default script